import axios from "axios";
import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";

export default function Messages() {



  const headers = {
    token: localStorage.getItem("userToken"),
  };

  const [MessagesData, setMessagesData] = useState([]);

  async function getMessageData() {
    try {
      const response = await axios.get(
        `https://vehex-production.up.railway.app/message`
      );
      console.log(response.data.messages);
      
      setMessagesData(response.data.messages);
    } catch (error) {
      console.error("Error fetching Message data:", error);
    }
  }

  async function deleteMessageData(id) {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          let response = await axios.delete(
            `https://vehex-production.up.railway.app/message/deleteMessage/${id}`,
            { headers }
          );

          if (response.data.message === "Message Deleted Successfully") {
            Swal.fire({
              title: "The Message has been deleted.",
              icon: "success",
              confirmButtonColor: "#3085d6",
            });
            getMessageData();

          }
        } catch (error) {
          console.error("Error deleting Message:", error);
          Swal.fire({
            title: "Error!",
            text: "There was an issue deleting the Message.",
            icon: "error",
            confirmButtonColor: "#d33",
          });
        }
      }
    });
  }

  useEffect(() => {
    getMessageData();
  }, []);
  return (
    <div className=" overflow-x-auto">
      {MessagesData?.length>0?<>
        <table className=" table table-striped">
      <thead>
        <tr>
          <th>Name</th>
          <th>Email</th>
          <th>Message</th>
          <th>Delete</th>
        </tr>
      </thead>
      <tbody>
        {MessagesData.map((MessageData) => (
          <tr key={MessageData._id}>
            <td>
              {MessageData?.name}
            </td>
            <td>
            {MessageData?.email}
            </td>
            <td>
            {MessageData?.description}
            </td>
            <td>
              <button
                className="btn btn-danger"
                onClick={() => deleteMessageData(MessageData._id)}
              >
                Delete
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
      </>:<div className="main-color fs-5 fw-500 text-center ">No Messages Found</div>}

  </div>
  )
}
